module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2021 by Philip Ball")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2021")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("30 29 28 27 26 25 24 23 22 21     1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "ac"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-71926-9 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "ac"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-77421-3 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "ac"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226774213.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226774213.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Ball, Philip, 1962– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: The modern myths : adventures in the machinery of the popular imagination / Philip Ball.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : University of Chicago Press, 2021. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("LCCN")]), _vm._v(" 2020044847 | "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226719269 (cloth) | "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226774213 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("LCSH")]), _vm._v(": Literature and myth. | Myth in mass media.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("LCC PN")]), _vm._v("56."), _c('span', {
    staticClass: "ac"
  }, [_vm._v("M")]), _vm._v("94 "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("B")]), _vm._v("35 2021 | "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("DDC")]), _vm._v(" 809/.915—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "ac"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2020044847",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020044847")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of "), _c('span', {
    staticClass: "ac"
  }, [_vm._v("ANSI/NISO Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493adab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-ball-0004.vue
// module id = 63
// module chunks = 0